import { render } from "./IsFeaturedIndex.vue?vue&type=template&id=7c7d0d0e"
import script from "./IsFeaturedIndex.vue?vue&type=script&lang=js"
export * from "./IsFeaturedIndex.vue?vue&type=script&lang=js"

import "./IsFeaturedIndex.vue?vue&type=style&index=0&id=7c7d0d0e&lang=css"

import exportComponent from "/Users/ratul/Code/vue/jourly-admin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__